import styled from 'styled-components'


export const Container = styled.div`
  display: flex;
  justify-content: flex-end;
`
export const Wrapper = styled.div`
  margin-left: 20px;
`
export const SideImage = styled.img`
  width: 130px;
  height: 90px; 
  object-fit: contain;
  display: flex;
  flex-direction: column;
  margin-bottom: 5px;
  cursor: pointer;
`